//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../Routing/Routing.RunItemsBuilderList.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/ObjectList.js";
let d=[[[1,"FromItemsList",0,"Routing.RunItemsBuilderList",0],[1,"MemberItems",0,"Routing.RouteObjectCollector",0],[0,"RunIdentifier",1,0],[0,"RunType",1,0],[0,"SpecificationOption",1,0],[1,"ToItemsList",0,"Routing.RunItemsBuilderList",0]],[[[],"UnifyPath",{},0,0],[[],"CreateRunItemsBuilder",{R_:{runItemsBuilder:"Routing.RunItemsBuilder"}},0,0],[["memberItem"],"AddMemberItems",{},1,0],[["memberItems"],"RemoveMemberItems",{},1,0]],[]];
SPLM.Routing.DefineRunBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.DefineRunBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;